import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { PageContainer } from '../app/AppLayout';
import { useApi } from '../api/context';
import { queryKeys } from '../api/queries';
import { useAuth } from '../auth/context';
import { PageHeader } from '../components/ui';
import { strings } from '../strings';

const s = strings.about;

export function AboutPage() {
  const { config, me } = useAuth();
  const api = useApi();
  const version = useQuery({
    queryKey: queryKeys.appVersion,
    queryFn: () => api.getAppVersion(),
    staleTime: Infinity,
  });
  const server = version.data?.version ?? config.version;
  const web = __NEBISYS_VERSION__;
  return (
    <PageContainer>
      <PageHeader title={s.title} />
      <p className="mb-4 max-w-2xl">{s.text}</p>
      <dl className="grid max-w-xl grid-cols-[auto_1fr] gap-x-4 gap-y-2 text-sm">
        <dt className="font-medium">{s.serverVersion}</dt>
        <dd data-testid="version">{server}</dd>
        {version.data && (
          <>
            <dt className="font-medium">{s.build}</dt>
            <dd className="font-mono" data-testid="build">
              {version.data.informationalVersion}
            </dd>
            <dt className="font-medium">{s.commit}</dt>
            <dd className={version.data.commit ? 'font-mono' : 'text-fg-muted'} data-testid="commit">
              {version.data.commit ?? s.noCommit}
            </dd>
          </>
        )}
        <dt className="font-medium">{s.webApp}</dt>
        <dd data-testid="web-version">{web}</dd>
        <dt className="font-medium">{s.user}</dt>
        <dd>{me.name}</dd>
        <dt className="font-medium">{s.roles}</dt>
        <dd data-testid="roles">{me.roles.join(', ')}</dd>
        <dt className="font-medium">{s.authMode}</dt>
        <dd>{config.auth.mode}</dd>
      </dl>
      {version.data && web !== server && (
        <p role="status" className="tone-warning mt-4 max-w-2xl rounded-lg border p-3 text-sm">
          {s.webAppDiffers(web, server)}
        </p>
      )}
      <p className="mt-4">
        <Link className="link" to="/whats-new">
          {s.whatsNew}
        </Link>
      </p>
    </PageContainer>
  );
}
